var __jsx = React.createElement;
import React, { memo } from "react";
import Head from "next/head";
import GlobalHeader from "../../Header/GlobalHeader";
function Header(_ref) {
  var title = _ref.title,
    isPublic = _ref.isPublic;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "tdm-reservation",
    content: "1"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "tdm-policy",
    content: "https://www.elsevier.com/tdm/tdmrep-policy.json"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    href: "".concat(process.env.customBasePath, "/static/images/ei_x.png"),
    type: "image/png"
  })), /*#__PURE__*/React.createElement(GlobalHeader, {
    isPublic: isPublic
  }));
}
export default /*#__PURE__*/memo(Header);